// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"94aca4a1","389":"5f129167","455":"b580e126","488":"b088d3e5","977":"a6eb3372"}[chunkId] + ".chunk.js";
};